import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, fontWeight, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { globalStyle, style } from '@vanilla-extract/css';

export const summarizePostButton = style({
  position: 'absolute',
  top: space.s4,
  right: space.s8,
  zIndex: 1,
  color: themeVars.container.foreground.brand,
});

export const summarizePostButtonIcon = style({
  selectors: {
    '&&': {
      color: themeVars.container.foreground.brand,
    },
  },
});

export const summarizePostButtonCompact = style({
  width: 16,
  height: 16,
});

globalStyle(`.${summarizePostButtonCompact} svg`, {
  width: 12,
  height: 12,
});

export const postSummaryContainer = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s8,
  padding: `${space.s8}px ${space.s12}px`,
  borderRadius: borderRadius.r8,
  backgroundColor: themeVars.container.secondary.background.idle,
});

export const postSummaryContainerCompact = style({
  marginTop: space.s6,
  gap: space.s4,
  padding: `${space.s6}px ${space.s8}px`,
});

export const postSummaryHeader = style([
  typography.labelMd,
  {
    display: 'flex',
    alignItems: 'center',
    gap: space.s4,
    color: themeVars.container.foreground.brand,
  },
]);

export const postSummaryHeaderCompact = style({
  fontWeight: fontWeight.regular,
  gap: space.s2,
});

export const postSummaryText = style([
  typography.bodyMd,
  {
    margin: 0,
    color: themeVars.container.foreground.primary,
  },
]);

export const postSummarySkeletons = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s6,
});
